import { render, staticRenderFns } from "./ResizableTextArea.vue?vue&type=template&id=016cfc6f&scoped=true"
import script from "./ResizableTextArea.vue?vue&type=script&lang=js"
export * from "./ResizableTextArea.vue?vue&type=script&lang=js"
import style0 from "./ResizableTextArea.vue?vue&type=style&index=0&id=016cfc6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016cfc6f",
  null
  
)

export default component.exports